import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import ApiRequest from "../helper/ApiRequest";
import { ApiEndpoints } from "../helper/ApiEndpoints";
import { Accordion, Card } from "react-bootstrap";

const websiteUrl = (pathname) =>
  `https://www.mobilityinfotech.com${pathname === "/" ? "/" : pathname.replace(/\/+$/, "")}`;

export default function GlobalFaq({ initialFaq = null }) {
  const location = useLocation();
  const initialPath = useRef(location.pathname);
  const usedInitialFaq = useRef(false);
  const currentPageUrl = websiteUrl(location.pathname);
  const initialFaqMatchesPage = initialFaq?.url === currentPageUrl;
  const [faqRecord, setFaqRecord] = useState(initialFaqMatchesPage ? initialFaq : null);
  const [activeKey, setActiveKey] = useState("0");
  const handleToggle = (key) => { setActiveKey((prevKey) => (prevKey === key ? null : key)); }

  useEffect(() => {
    if (!usedInitialFaq.current && location.pathname === initialPath.current) {
      usedInitialFaq.current = true;
      if (initialFaqMatchesPage) return;
    }

    let cancelled = false;
    setFaqRecord(null);
    const loadFaq = async () => {
      try {
        const endpoint = `${ApiEndpoints.faq.faqByUrl}?url=${encodeURIComponent(currentPageUrl)}`;
        const response = await ApiRequest("GET", endpoint);
        if (!cancelled) setFaqRecord(response.faq || null);
      } catch (error) {
        if (!cancelled) setFaqRecord(null);
        console.error("Unable to load page FAQs:", error);
      }
    };
    loadFaq();
    return () => { cancelled = true; };
  }, [currentPageUrl, initialFaqMatchesPage, location.pathname]);

  const items = faqRecord?.faqs || [];

  if (!items.length) return null;

  return (
    <section className="carpool-faq">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="heading center-heading">Frequently <span className="gradiant-color"> Asked Questions</span></h4>
            <Accordion activeKey={activeKey} className="faq-accord">
              {items.map((faq, ind) => (
                <Card key={`${ind}`} className={activeKey === `${ind}` ? "active" : ""}>
                  <Card.Header>
                    <Accordion.Item eventKey={`${ind}`}>
                      <Accordion.Header as="small" onClick={() => handleToggle(`${ind}`)}>
                        <label>{faq?.question}</label>
                        <span>{activeKey === `${ind}` ? "-" : "+"}</span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>{faq?.answer}</p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card.Header>
                </Card>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
